import { claimBillText } from "@/constants/bills";

export const getRecentInvoices = (bills) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  return bills.filter((invoice) => {
    const [year, month, day] = invoice.billDate.split('-').map(Number);

    if (year !== currentYear || month !== currentMonth) {
      return false;
    }

    // Verificar si la factura tiene menos de 7 días
    const invoiceDate = new Date(year, month - 1, day);
    const differenceInDays = Math.ceil((today - invoiceDate) / (1000 * 60 * 60 * 24));
    return differenceInDays < 3;
  });
}

export const hasOpenClaims = (bills) => {
  for (const bill of bills) {
    const { listaReclamaciones } = bill;
    if (listaReclamaciones && Array.isArray(listaReclamaciones) && listaReclamaciones.length > 0) {
      for (const claim of listaReclamaciones) {
        const { phase } = claim;
        if (
          phase === claimBillText.statusOpen ||
          phase === claimBillText.statusOngoing ||
          phase === claimBillText.statusResolution
        ) {
          return true;
        }
      }
    }
  }
  return false;
};

export const hasEndClaims = (bills) => {
  for (const bill of bills) {
    const { listaReclamaciones } = bill;
    if (listaReclamaciones && Array.isArray(listaReclamaciones) && listaReclamaciones.length > 0) {
      for (const claim of listaReclamaciones) {
        const { phase } = claim;
        if (phase === claimBillText.statusEnded) {
          return true;
        }
      }
    }
  }
  return false;
};
